(function () {
  if (window.__APSEL_SYNC_UPSELLS__) return;
  window.__APSEL_SYNC_UPSELLS__ = true;

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  }

  function setSelected(upsellEl, selected) {
    upsellEl.dataset.selected = selected ? 'true' : 'false';

    const btn = upsellEl.querySelector('.toggle-switch, .upsell__toggle-switch, .upsell__checkbox, .upsell__plus-btn');
    if (btn) {
      btn.classList.toggle('is-selected', !!selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }

    upsellEl.classList.toggle('is-selected', !!selected);
  }

  async function syncUpsellsWithCart() {
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      console.warn('[Apsel] sync error:', e);
      return;
    }

    const variantIdsInCart = new Set((cart.items || []).map(i => Number(i.id)));

    const upsells = document.querySelectorAll('cart-drawer-upsell, cart-upsell, product-upsell, [data-variant-id]');
    upsells.forEach(el => {
      const vid = Number(el.dataset.variantId || el.getAttribute('data-variant-id'));
      if (!vid) return;
      setSelected(el, variantIdsInCart.has(vid));
    });
  }

  document.addEventListener('DOMContentLoaded', syncUpsellsWithCart);
  document.addEventListener('cart:refresh', syncUpsellsWithCart);
  document.addEventListener('cart:updated', syncUpsellsWithCart);
  document.addEventListener('cart:change', syncUpsellsWithCart);

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form) return;
    if (form.matches('form[action*="/cart/add"], product-form form')) {
      setTimeout(syncUpsellsWithCart, 600);
      setTimeout(syncUpsellsWithCart, 1400);
    }
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[name="add"], .bundle-add, [data-add-to-cart]');
    if (!btn) return;
    setTimeout(syncUpsellsWithCart, 600);
    setTimeout(syncUpsellsWithCart, 1400);
  }, true);

})();